var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:{
    'size-large': _vm.size === 'large',
    'size-medium': _vm.size === 'medium',
    'size-small': _vm.size === 'small'
  },attrs:{"for":_vm.name}},[_vm._t("default"),(_vm.required)?_c('span',[_vm._v("(required)")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }